import { api, ApiError } from '@/lib/api';

import { lerMe } from '@alianca/core/contracts/me';
import type { Me } from '@alianca/core/contracts/me';

let cached: Promise<Me | null> | null = null;

/** `GET /api/me` memoizado por carga de página. 401/403 ⇒ `null` (o `api()` já redirecionou). */
export function getMe(): Promise<Me | null> {
    cached ??= api(lerMe, {})
        .then((me) => {
            if (me.needsRegistration) window.location.assign('/auth/complete-registration');
            return me;
        })
        .catch((e: unknown) => {
            cached = null;
            if (e instanceof ApiError && (e.status === 401 || e.status === 403)) return null;
            throw e;
        });
    return cached;
}

export const invalidateMe = (): void => {
    cached = null;
};
